module.exports = __webpack_public_path__ + "img/logo-ifitej-gris.06881aad.png";